import React from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';

const TrailResultCardShimmer = ({ className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.image} />
      <div className={styles.metadataContainer}>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

TrailResultCardShimmer.propTypes = {
  className: string
};

TrailResultCardShimmer.defaultProps = {
  className: ''
};

export default TrailResultCardShimmer;
